import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import { flagColor } from '@opsbase/lib-issue/Flag';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useSelfActions from '@opsbase/react-ctrl-self/useSelfActions';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import useOrgUpdate from '@opsbase/react-gql-hooks/organisation/useOrgUpdate';
import markdown from '@opsbase/react-markdown';
import AppPage from '@opsbase/web-app/AppPage';
import EditableList from '@opsbase/web-editablelist';
import FlagIcon from '@opsbase/web-icons/icons/FlagIcon';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
export function AdvancedIssueFlagsPage() {
    var _a, _b;
    const self = useSelf();
    const { updateSettings } = useSelfActions();
    const { data: org } = useOrgFindById({ variables: { id: self.organisationId } });
    const updateOrg = useOrgUpdate();
    const flagNames = (_a = org === null || org === void 0 ? void 0 : org.settings) === null || _a === void 0 ? void 0 : _a.flagNames;
    const flagNamesOptions = (_b = Object.keys(flagNames || {})) === null || _b === void 0 ? void 0 : _b.map(flag => ({
        flag,
        title: flagNames[flag] || 'Uncategorised',
    }));
    const handleChange = useCallback(options => {
        const newFlagNames = { ...org.settings.flagNames };
        options.forEach(o => (newFlagNames[o.flag] = o.title));
        const patch = {
            settings: {
                flagNames: newFlagNames,
            },
        };
        updateOrg({
            id: org.id,
            patch,
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updateOrg: {
                    __typename: 'Organisation',
                    ...org,
                    ...patch,
                },
            },
        })
            .then(updatedOrg => {
            updateSettings(updatedOrg.settings);
        })
            .catch(doNothing);
    }, [org, updateSettings, updateOrg]);
    const handleAfterItem = useCallback(option => (React.createElement(Pane, null,
        React.createElement(FlagIcon, { htmlColor: flagColor(option.flag).main }))), []);
    return (React.createElement(AppPage, null,
        React.createElement(Vertical, { padding: true, style: { overflow: 'auto' } },
            React.createElement(Pane, { padding: true },
                React.createElement(Text, { variant: "h2" }, markdown(i18n.t('issue-label-question'))),
                !!(flagNamesOptions === null || flagNamesOptions === void 0 ? void 0 : flagNamesOptions.length) && (React.createElement("div", { style: { width: 500 } },
                    React.createElement(EditableList, { autoSelectIdx: 0, items: flagNamesOptions, valueField: "title", idField: "flag", onChange: handleChange, afterItem: handleAfterItem })))))));
}
export default AdvancedIssueFlagsPage;
